import IBAN from 'iban';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

var regExpStatments = {
  email: {
    name: 'email',
    regex: /^\s*[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*(\+[a-zA-Z0-9-]+)?@[a-zA-Z0-9-.]+(\.[a-zA-Z0-9]+)\s*$/,
    description: 'this pattern is used to check if the email is valid'
  },
  lettersMinimum_3: {
    name: 'lettersMinimum_3',
    regex: /^[a-zA-Z]{3,}$/,
    description: 'this pattern is used to validate that the input length is at least 3 letter'
  },
  name: {
    name: 'name',
    regex: /^([^0-9!“§$%&/()=?`;:_.,#+*’^°´@{}"[\]<>±|\\]*)$/,
    description: 'This pattern is used to validate that the input does not contain numbers, and some symbols.'
  },
  blockName: {
    name: 'name',
    regex: /^([^!“§$%&/()=?`;:_.,#+*’^°´@{}"[\]<>±|\\]*)$/,
    description: 'This pattern is used to validate that the input does not contain special symbols'
  },
  numbersMinimum_6: {
    name: 'numbersMinimum_6',
    regex: /^[0-9]{6,}$/,
    description: 'this pattern is used to validate that the input length is at least 6 numbers'
  },
  numbersTelephone_6: {
    name: 'numbersTelephone_6',
    regex: /^[+]*[0-9]{6,}$/,
    description: 'this pattern is used to validate that the input length is at least 6 numbers and it could start with + sign'
  },
  numbersExact_11: {
    name: 'numbersExact_11',
    regex: /^[0-9]{11,11}$/,
    description: 'this pattern is used to validate that the input length exactly 12 numbers'
  },
  numbersMaximum_11: {
    name: 'numbersMaximum_11',
    regex: /^[0-9]{1,11}$/,
    description: 'this pattern is used to validate that the input length is maximum 11 numbers'
  },
  date_de: {
    name: 'date_de',
    regex: /^[0-3][0-9][.][0-1][0-9][.][1|2][0-9]{3}$/,
    description: 'this pattern is used to validate that the input is valid german date DD.MM.YYYY'
  },
  telephone_de: {
    name: 'telephone_de',
    regex: /^([+][0-9]{1,3}[ .-]?)?([(]{1}[0-9]{1,6}[)])?([0-9 .-/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
    description: 'this pattern is used to validate that the input is a german telephone'
  }
};

dayjs.extend(customParseFormat);
/**
 * Validates that a date is actually valid
 * @param data date as string in DD.MM.YYYY
 * @returns boolean
 */

function validateDate(data) {
  return dayjs(data, 'DD.MM.YYYY', true).isValid();
}
/**
 * Validate date in german format is in the past
 * @param data date as string DD.MM.YYY
 * @returns boolean
 */

function validateBirthDate(data) {
  var de_date = regExpStatments.date_de.regex; // check if the data format matches the de format and the date in the past

  if (de_date.test(data)) {
    if (parseDateDE(data).getTime() < new Date().getTime()) {
      return true;
    }
  }

  return false;
}
/**
 * Validate date is 14 days in the future
 * @param data date as string DD.MM.YYY
 * @returns boolean
 */

function validateFutureDate(data) {
  var de_date = regExpStatments.date_de.regex; // check if the data format matches the de format

  if (de_date.test(data)) {
    if (parseDateDE(data).getTime() > new Date().getTime() + 14 * 24 * 60 * 60 * 1000) {
      return true;
    }
  }

  return false;
}
function parseDateDE(dateStr) {
  var dateArray = dateStr.split('.');
  var date = new Date();
  date.setFullYear(+dateArray[2], +dateArray[1] - 1, +dateArray[0]);
  return date;
}
/**
 * Validate iban and validate its syntax
 * @param data iban string
 * @returns boolean
 */

function validateIBAN(data) {
  return IBAN.isValid(data);
}
var functionalValidators = {
  iban: {
    name: 'iban',
    callback: validateIBAN,
    description: 'this validation function will validate the syntax of the provided iban'
  },
  birth_date: {
    name: 'birth_date',
    callback: validateBirthDate,
    description: 'this function will validate that the date is in the past'
  },
  future_date_14: {
    name: 'future_date_14',
    callback: validateFutureDate,
    description: 'this function will validate that the date is in the future with 14 days at least'
  }
};
var IBAN_Specifications = IBAN.countries;

var schemaKeywords = [{
  keyword: 'email',
  callback: function callback(schema, data) {
    return schema ? regExpStatments.email.regex.test(data) : false;
  },
  errorMessage: {
    en: 'Please enter a valid email address.',
    de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
  }
}, {
  keyword: 'onlyLetters',
  callback: function callback(schema, data) {
    return schema ? /^[a-zA-Z]+$/.test(data) : false;
  },
  errorMessage: {
    en: 'Only letters allowed.',
    de: 'Nur Buchstaben erlaubt.'
  }
}, {
  keyword: 'onlyNumbers',
  callback: function callback(schema, data) {
    return schema ? /^[0-9]+$/.test(data) : false;
  },
  errorMessage: {
    en: 'Only numbers allowed.',
    de: 'Nur Zahlen erlaubt.'
  }
}, {
  keyword: 'dateDE',
  callback: function callback(schema, data) {
    return schema ? regExpStatments.date_de.regex.test(data) : false;
  },
  errorMessage: {
    en: 'Date should have the format DD.MM.YYYY.',
    de: 'Das Datum sollte das Format TT.MM.JJJJ haben.'
  }
}, {
  keyword: 'minNumbersTelephone',
  callback: function callback(schema, data) {
    return schema && typeof schema === 'number' ? new RegExp("^[+]*[0-9]{" + schema + ",}$").test(data) : false;
  },
  errorMessage: {
    en: 'Please enter a valid telephone number.',
    de: 'Bitte geben Sie eine gültige Telefonnummer ein.'
  }
}, {
  keyword: 'validDateDE',
  callback: function callback(schema, data) {
    return schema ? validateDate(data) : false;
  },
  errorMessage: {
    en: 'Please enter a valid date.',
    de: 'Bitte geben Sie ein gültiges datum ein.'
  }
}, {
  keyword: 'futureDateDE',
  callback: function callback(schema, data) {
    return schema && typeof schema === 'number' ? parseDateDE(data).getTime() > new Date().getTime() + schema * 24 * 60 * 60 * 1000 : false;
  },
  errorMessage: {
    en: 'The date must be at least {schema} days in the future.',
    de: 'Das Datum muss mind. {schema} Tage in der Zukunft liegen.'
  }
}, {
  keyword: 'rangeDateDE',
  callback: function callback(schema, data) {
    return schema && Array.isArray(schema) && schema.length === 2 ? parseDateDE(data).getTime() >= new Date().getTime() + schema[0] * 24 * 60 * 60 * 1000 && parseDateDE(data).getTime() <= new Date().getTime() + schema[1] * 24 * 60 * 60 * 1000 : false;
  },
  errorMessage: {
    en: 'Date must be between {minDate} and {maxDate}.',
    de: 'Datum muss zwischen {minDate} und {maxDate} liegen.'
  }
}, {
  keyword: 'birthdateDE',
  callback: function callback(schema, data) {
    return schema ? parseDateDE(data).getTime() < new Date().getTime() : false;
  },
  errorMessage: {
    en: 'Please enter a valid date of birth.',
    de: 'Bitte geben Sie ein gültiges Geburtsdatum ein.'
  }
}];

function convertDate(date, separator) {
  if (separator === void 0) {
    separator = '.';
  }

  function pad(s) {
    return s < 10 ? '0' + s : s;
  }

  return [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join(separator);
}

function validateSchemaKeyword(schemaKeyword, locale) {
  var keyword = schemaKeyword.keyword,
      callback = schemaKeyword.callback,
      errorMessage = schemaKeyword.errorMessage;

  var validate = function validate(schema, data) {
    switch (keyword) {
      case 'rangeDateDE':
        {
          var minDays = schema[0],
              maxDays = schema[1];
          var minDate = new Date();
          minDate.setDate(minDate.getDate() + minDays);
          var maxDate = new Date();
          maxDate.setDate(maxDate.getDate() + maxDays);
          validate.errors = [{
            keyword: keyword,
            message: errorMessage[locale || 'de'].replace('{minDate}', convertDate(minDate)).replace('{maxDate}', convertDate(maxDate)),
            params: {
              keyword: keyword
            }
          }];
          break;
        }

      default:
        validate.errors = [{
          keyword: keyword,
          message: errorMessage ? errorMessage[locale || 'de'].replace('{schema}', schema) : locale === 'en' ? 'The entered format is invalid.' : 'Das eingegebene Format ist ungültig.',
          params: {
            keyword: keyword
          }
        }];
        break;
    }

    return callback(schema, data);
  };

  return validate;
}

export { IBAN_Specifications, functionalValidators, parseDateDE, regExpStatments, schemaKeywords, validateBirthDate, validateDate, validateFutureDate, validateIBAN, validateSchemaKeyword };
//# sourceMappingURL=validators.esm.js.map
